import { FC, PropsWithChildren, createContext, useState } from 'react'

import { VOID_FUNC } from '@hap/constants'

import { LoadingContextProps } from './types'

export const LoadingContext = createContext<LoadingContextProps>({
  isLoading: false,
  showLoader: VOID_FUNC,
  hideLoader: VOID_FUNC,
})

export const LoadingProvider: FC<PropsWithChildren> = (props) => {
  const [loading, setLoading] = useState(false)
  return (
    <LoadingContext.Provider
      value={{
        isLoading: loading,
        showLoader: () => setLoading(true),
        hideLoader: () => setLoading(false),
      }}
    >
      {props.children}
    </LoadingContext.Provider>
  )
}
